import React from 'react';

const Logo: React.FC = () => {
  return (
    <div className="flex items-center">
      <div className="rounded-lg overflow-hidden z-50 relative">
        <img 
          src="/quote-vibes-logo.png" 
          alt="Quote Vibes Daily Logo"
          width={40}
          height={40}
          className="rounded-lg"
        />
      </div>
    </div>
  );
};

export default Logo; 